// extracted by mini-css-extract-plugin
module.exports = {"lang":"LangMenu_lang__2eAp0","langAfs":"LangMenu_langAfs__3_rs0","langIpc":"LangMenu_langIpc__1O7IZ","active":"LangMenu_active__1UWVw"};